module.exports = __webpack_public_path__ + "static/media/baruch-logo.a385061d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/baruch-logo.svg
// module id = 329
// module chunks = 0